export const RequstMethods= {
    GET : 'get',
    PUT : 'put',
    POST : 'post',
    DELETE : 'delete'
}